const jazzHr = {
  displayField: 'heading',
  name: 'JazzHr',
  description: 'Current Openings (Jazz HR)',
  fields: [
    {
      id: 'heading',
      name: 'heading',
      type: 'Symbol',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'subHeading',
      name: 'subHeading',
      type: 'Symbol',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: { id: 'jazzHr', version: 10, updatedAt: '2023-08-02T22:07:16.422Z' }
};
export default jazzHr;